export function getSelectedIds<T extends { id: number }>(
  value: T | T[] | number | number[] | null | undefined
): number[] {
  if (!value) return [];

  if (Array.isArray(value)) {
    if (!value.length) return []; // avoid value[0] undefined crash

    return typeof value[0] === 'number'
      ? value as number[]
      : value.map(v => v.id);
  }

  return typeof value === 'number'
    ? [value]
    : [value?.id];
}

export function mapIdsToObjects<T extends { id: number }>(
  ids: number[] | null | undefined,
  items: T[],
  multiple: boolean
): T | T[] | null {
  if (!ids || !ids.length) return multiple ? [] : null;

  const mapped = ids
    .map(id => items.find(i => i.id === id))
    .filter((v): v is T => Boolean(v)); // stronger TS narrowing

  if (!mapped.length) return multiple ? [] : null;

  return multiple ? mapped : mapped[0];
}
